export const EVENTS = {
    'SHARE_GENERATE': 'share_generate',
    'LOGIN_BTN': 'login_btn',
    'SHARE_BTN': 'share_btn',
    'DOWNLOAD_BTN': 'download_btn',
    'PAGE_VISITED': 'page_visited',
    'REGENRATE_BTN': 'regenrate_btn',
    'GET_APP': 'get_app_btn'
}